module.exports = __webpack_public_path__ + "img/SUITE_WORD_BLACK.4843451c.png";